import { FrequentPassageRequest } from '@legacy-types';

import { api } from '@shared/api/api';
import { Nullable } from '@shared/utils/types/Nullable';

export type CreateFrequentPassageRequestData = Nullable<
  Pick<
    FrequentPassageRequest,
    'registrationId' | 'crewMemberId' | 'vehicleType' | 'licensePlate' | 'frequentPassageStickerTypeId'
  >
>;

export const createFrequentPassageRequest = api.createCreate<CreateFrequentPassageRequestData, FrequentPassageRequest>(
  'frequent-passage-requests'
);
